import { ScrollingModule } from '@angular/cdk/scrolling';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AiNocComponent } from './ai-noc/ai-noc.component';
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModalModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { LightgalleryModule } from 'lightgallery/angular';
import { NgChartsModule } from 'ng2-charts';
import { ToastrModule } from 'ngx-toastr';
import { WorkingListComponent } from 'src/app/fleet-tracker/working-list/working-list.component';
import { LoadingIndicatorComponent } from 'src/app/shared/loading-indicator/loading-indicator.component';
import { SpinnerComponent } from 'src/app/shared/spinner/spinner.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SessionService } from './auth/session/session.service';
import { CohortApprovalModalComponent } from './cohorts/cohort-approval-modal/cohort-approval-modal.component';
import { CohortEntitiesDetailsComponent } from './cohorts/cohort-entities-details/cohort-entities-details.component';
import { CohortModalComponent } from './cohorts/cohort-modal/cohort-modal.component';
import { CohortOwnerInputComponent } from './cohorts/cohort-owner-input/cohort-owner-input.component';
import { CohortSearchInputComponent } from './cohorts/cohort-search-input/cohort-search-input.component';
import { CohortStatusCellComponent } from './cohorts/cohort-status-cell/cohort-status-cell.component';
import { CohortStatusIndicatorComponent } from './cohorts/cohort-status-indicator/cohort-status-indicator.component';
import { CohortQueryComponent } from './cohorts/cohorts-query/cohort-query.component';
import { CohortsComponent } from './cohorts/cohorts.component';
import { CohortBulkImportComponent } from './cohorts/create-cohort/bulk-cohort-add/bulk-cohort-add.component';
import { CreateCohortComponent } from './cohorts/create-cohort/create-cohort.component';
import { DashboardsComponent } from './dashboards/dashboards.component';
import { CommandRequestDetailsModalLinkComponent } from './device-command/command-request-details-modal-link/command-request-details-modal-link.component';
import { CommandRequestDetailsModalComponent } from './device-command/command-request-details-modal/command-request-details-modal.component';
import { CommandRequestModalComponent } from './device-command/command-request-modal/command-request-modal.component';
import { CommandStatusComponent } from './device-command/command-status/command-status.component';
import { DeviceCommandComponent } from './device-command/device-command.component';
import { DeviceHealthComponent } from './device-health/device-health.component';
import { HealthQueryBuilderComponent } from './device-health/query-builder/health-query-builder.component';
import { StatusReportHeader } from './device-health/status-report-header/status-report-header.component';
import { FleetTrackerIconService } from './fleet-tracker/fleet-tracker-icon.service';
import { FleetTrackerUtilityService } from './fleet-tracker/fleet-tracker-utility.service';
import { FleetTrackerConfig } from './fleet-tracker/fleet-tracker.config';
import { FleetTrackerModule } from './fleet-tracker/fleet-tracker.module';
import { FloatingMenuComponent } from './fleet-tracker/floating-menu-component/floating-menu.component';
import { GoogleMapsWrapperComponent } from './fleet-tracker/google-maps-wrapper/google-maps-wrapper.component';
import { MapDrawerComponent } from './fleet-tracker/map-drawer/map-drawer.component';
import { MapScriptLoaderService } from './fleet-tracker/map-script-loader.service';
import { MapComponent } from './fleet-tracker/map/map.component';
import { WorkingListSearchComponent } from './fleet-tracker/working-list/search/search.component';
import { HomeComponent } from './home/home.component';
import { InsightsPageComponent } from './insights/insights-page.component';
import { CohortsModalRendererComponent } from './insights/pages/apps/cohorts-modal-link-renderer/cohorts-modal-renderer.component';
import { DeviceVersionsQueryComponent } from './insights/pages/apps/device-version-query/device-versions-query.component';
import { ModuleStatusComponent } from './insights/pages/apps/module-status/module-status.component';
import { ModulesInsightsComponent } from './insights/pages/apps/modules-insights.component';
import { DeviceBatteryInsightsComponent } from './insights/pages/shadow-battery/device-battery-insights.component';
import { DevicesInsightsComponent } from './insights/pages/shadow-devices/devices-insights.component';
import { IgnitionInsightsComponent } from './insights/pages/shadow-ignition/ignition-insights.component';
import { OverdueInsightsComponent } from './insights/pages/shadow-overdue/overdue-insights.component';
import { QueryBuilderComponent } from './insights/query-builder/query-builder.component';
import { QueryFilterComponent } from './insights/query-builder/query-filter/query-filter.component';
import { LytxPlatformComponentsModule } from './lytx-platform-components/lytx-platform-components.module';
import { CreateCoreFirmwareVersionComponent } from './modules/create-core-firmware-version/create-core-firmware-version.component';
import { CreateModuleVersionComponent } from './modules/create-module-version/create-module-version.component';
import { CreateModuleComponent } from './modules/create-module/create-module.component';
import { FirmwareDetailsComponent } from './modules/firmware-details/firmware-details.component';
import { ModuleCardDisplayComponent } from './modules/module-card-display/module-card-display.component';
import { ModuleDetailsComponent } from './modules/module-details/module-details.component';
import { ModuleSpinnerComponent } from './modules/module-spinner/module-spinner.component';
import { ModulesComponent } from './modules/modules.component';
import { ViewCoreFirmwareModalComponent } from './modules/view-core-firmware-modal/view-core-firmware-modal.component';
import { ViewModuleVersionModalComponent } from './modules/view-module-version-modal/view-module-version-modal.component';
import { DeviceMonitoringModalLinkComponent } from './monitoring/device-monitoring-modal-link/device-monitoring-modal-link.component';
import { DeviceMonitoringModalComponent } from './monitoring/device-monitoring-modal/device-monitoring-modal.component';
import { DeviceProfilePageComponent } from './monitoring/device-profile-page/device-profile-page.component';
import { HubAuxModalComponent } from './monitoring/hub-aux-modal/hub-aux-modal.component';
import { DeviceMonitoringSearchComponent } from './monitoring/device-monitoring-search/device-monitoring-search.component';
import { DevicemonitoringComponent } from './monitoring/device-monitoring/devicemonitoring.component';
import { DeviceEventModalComponent } from './monitoring/device-timeline/device-event-modal-section/device-event-modal.component';
import { DeviceMetadataSectionComponent } from './monitoring/device-timeline/device-metadata-section/device-metadata-section.component';
import { DeviceTimelineRowComponent } from './monitoring/device-timeline/device-timeline-row/device-timeline-row.component';
import { TimelineComponent } from './monitoring/device-timeline/timeline.component';
import { TimestampRowComponent } from './monitoring/timestamp-row/timestamp-row.component';
import { OffVpnComponent } from './off-vpn/off-vpn.component';
import { PermissionsModule } from './permissions/permissions.module';
import { OrderByIndexPipe } from './pipes/order-by-index/order-by-index.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { AppSelectorComponent } from './releases/app-selector/app-selector.component';
import { AppsColumnViewComponentTooltip } from './releases/apps-column-view-tooltip/apps-column-view-tooltip.component';
import { CohortsColumnViewToolTipComponent } from './releases/cohorts-column-view-tooltip/cohorts-column-view-tooltip.component';
import { CohortsColumnViewComponent } from './releases/cohorts-column-view/cohorts-column-view.component';
import { CreateReleaseComponent } from './releases/create-release/create-release.component';
import { PhaseCohortsDetailsComponent } from './releases/phase-cohorts-details/phase-cohorts-details.component';
import { ModuleChangeDetailsComponent } from './releases/release-approval-modal/module-change-details/module-change-details.component';
import { ReleaseApprovalModalComponent } from './releases/release-approval-modal/release-approval-modal.component';
import { ReleaseOwnerInputComponent } from './releases/release-owner/release-owner-input.component';
import { ReleaseQueryComponent } from './releases/release-query/release-query.component';
import { ReleaseNameInputComponent } from './releases/release-search/release-name-input.component';
import { ReleaseStatusComponent } from './releases/release-status-component/release-status.component';
import { ReleaseViewConfigModalComponent } from './releases/release-view-config-modal/release-view-config-modal.component';
import { ReleaseViewModalComponent } from './releases/release-view-modal/release-view-modal.component';
import { ReleasesComponent } from './releases/releases.component';
import { NewRequestComponent } from './request-grid/new-request/new-request.component';
import { LiveSyslogComponent } from './request-grid/live-syslog/live-syslog.component';
import { LiveSyslogHelpComponent } from './request-grid/live-syslog/live-syslog-help/live-syslog-help.component';
import { RequestGridComponent } from './request-grid/request-grid.component';
import { ViewOrDownloadComponent } from './request-grid/view-or-download/view-or-download.component';
import { BtnReviewRequestComponent } from './settings/button-review-request/button-review-request.component';
import { EntityDisplayComponent } from './settings/display-entities/display-entities.component';
import { EntityPathDisplayComponent } from './settings/entity-path-display/entity-path-display.component';
import { SettingsHierarchyComponent } from './settings/hierarchy/settings-hierarchy.component';
import { BulkEntityInputComponent } from './settings/request-creation-modal/bulk-entity-input/bulk-entity-input.component';
import { CompanySelectorComponent } from './settings/request-creation-modal/company-selector/company-selector.component';
import { SettingsRequestCreationModalComponent } from './settings/request-creation-modal/request-creation-modal.component';
import { SettingSelectorComponent } from './settings/request-creation-modal/setting-selector/setting-selector.component';
import { SettingValueSelectorComponent } from './settings/request-creation-modal/setting-value-selector/setting-value-selector.component';
import { VideoProfileSelectorComponent } from './settings/request-creation-modal/video-profile-selector/video-profile-selector.component';
import { RequestQueryBuilderComponent } from './settings/request-query-builder/request-query-builder.component';
import { SettingsRequestReviewModalComponent } from './settings/request-review-modal/request-review-modal.component';
import { SettingsRequestViewModalComponent } from './settings/request-view-modal/request-view-modal.component';
import { SettingsRequestsComponent } from './settings/requests/settings-requests.component';
import { PromoteSettingModalComponent } from './settings/promote-setting-modal/promote-setting-modal.component';
import { SettingNamePipe } from './settings/setting-name.pipe';
import { SettingUnitsPipe } from './settings/setting-units.pipe';
import { SettingValuePipe } from './settings/setting-value.pipe';
import { SettingsBreadcrumbs } from './settings/settings-breadcrumbs/settings-breadcrumbs.component';
import { SettingsGridComponent } from './settings/settings-grid/settings-grid.component';
import { SettingsTypesComponent } from './settings/settings-types/settings-types.component';
import { SettingsTypesAuditComponent } from './settings/settings-types-audit/settings-types-audit.component';
import { ValueCellComponent } from './settings/settings-grid/value-cell/value-cell.component';
import { VideoProfileCellComponent } from './settings/settings-grid/video-profile-cell/video-profile-cell.component';
import { HistoryCellComponent } from './settings/settings-history/history-cell/history-cell.component';
import { SettingsHistoryComponent } from './settings/settings-history/settings-history.component';
import { SettingsTopBarComponent } from './settings/settings-top-bar/settings-top-bar.component';
import { SettingsComponent } from './settings/settings.component';
import { BillboardComponent } from './shared/billboard/billboard.component';
import { BackButtonComponent } from './shared/buttons/back-button/back-button.component';
import { CloseButtonComponent } from './shared/buttons/close-button/close-button.component';
import { DownloadCsvButtonComponent } from './shared/buttons/download-csv-button/download-csv-button.component';
import { ResetButtonComponent } from './shared/buttons/reset-button/reset-button.component';
import { SearchButtonComponent } from './shared/buttons/search-button/search-button.component';
import { ShareLinkButtonComponent } from './shared/buttons/share-link-button/share-link-button.component';
import { ChipComponent } from './shared/chip/chip.component';
import { DropdownComponent } from './shared/dropdown/dropdown.component';
import { EntityPathPipe } from './shared/entity-search/entity-path.pipe';
import { EntitySearchComponent } from './shared/entity-search/entity-search.component';
import { FirmwareSearchComponent } from './shared/firmware-version-search/firmware-version-search.component';
import { FooterItemsDropdownComponent } from './shared/footer-items-dropdown/footer-items-dropdown.component';
import { PaginatorComponent } from './shared/paginator/paginator.component';
import { SharedModule } from './shared/shared.module';
import { SimplePaginatorComponent } from './shared/simple-paginator/simple-paginator.component';
import { TabbedNavigationComponent } from './shared/tabbed-navigation/tabbed-navigation.component';
import { NewSettingModalComponent } from './settings/new-setting-modal/new-setting-modal.component';
import { CompressionInterceptor } from './core/compression-interceptor/compression.interceptor';
import { DeviceViewService } from 'src/app/shared/services/device-view/device-view.service';

@NgModule({
  declarations: [
    AiNocComponent,
    AppComponent,
    AppsColumnViewComponentTooltip,
    AppSelectorComponent,
    BtnReviewRequestComponent,
    CohortBulkImportComponent,
    BulkEntityInputComponent,
    CohortApprovalModalComponent,
    CohortEntitiesDetailsComponent,
    CohortsColumnViewComponent,
    CohortsColumnViewToolTipComponent,
    CohortsComponent,
    CohortQueryComponent,
    CohortModalComponent,
    CohortsModalRendererComponent,
    CohortOwnerInputComponent,
    CohortStatusCellComponent,
    CohortSearchInputComponent,
    CommandRequestDetailsModalComponent,
    CommandRequestDetailsModalLinkComponent,
    CommandRequestModalComponent,
    CommandStatusComponent,
    CompanySelectorComponent,
    CreateCohortComponent,
    CreateCoreFirmwareVersionComponent,
    CreateModuleComponent,
    CreateModuleVersionComponent,
    CreateReleaseComponent,
    DashboardsComponent,
    DeviceBatteryInsightsComponent,
    DeviceCommandComponent,
    DeviceEventModalComponent,
    DeviceHealthComponent,
    DeviceMetadataSectionComponent,
    DevicemonitoringComponent,
    DeviceMonitoringModalComponent,
    DeviceMonitoringModalLinkComponent,
    DeviceMonitoringSearchComponent,
    DeviceProfilePageComponent,
    HubAuxModalComponent,
    DevicesInsightsComponent,
    DeviceTimelineRowComponent,
    DeviceVersionsQueryComponent,
    EntityDisplayComponent,
    EntityPathDisplayComponent,
    FirmwareDetailsComponent,
    FirmwareSearchComponent,
    FloatingMenuComponent,
    FooterItemsDropdownComponent,
    GoogleMapsWrapperComponent,
    HealthQueryBuilderComponent,
    HistoryCellComponent,
    HomeComponent,
    IgnitionInsightsComponent,
    InsightsPageComponent,
    MapComponent,
    MapDrawerComponent,
    ModuleCardDisplayComponent,
    ModuleChangeDetailsComponent,
    ModuleDetailsComponent,
    ModulesComponent,
    ModulesInsightsComponent,
    ModuleSpinnerComponent,
    ModuleStatusComponent,
    NewRequestComponent,
    LiveSyslogComponent,
    LiveSyslogHelpComponent,
    OffVpnComponent,
    OrderByIndexPipe,
    OrderByPipe,
    OverdueInsightsComponent,
    PaginatorComponent,
    PhaseCohortsDetailsComponent,
    QueryBuilderComponent,
    QueryFilterComponent,
    ReleaseApprovalModalComponent,
    ReleasesComponent,
    ReleaseOwnerInputComponent,
    ReleaseStatusComponent,
    ReleaseNameInputComponent,
    ReleaseViewConfigModalComponent,
    ReleaseViewModalComponent,
    RequestGridComponent,
    RequestQueryBuilderComponent,
    ReleaseQueryComponent,
    SettingNamePipe,
    SettingsBreadcrumbs,
    SettingsComponent,
    SettingSelectorComponent,
    SettingsGridComponent,
    SettingsHierarchyComponent,
    SettingsHistoryComponent,
    SettingsRequestCreationModalComponent,
    SettingsRequestReviewModalComponent,
    SettingsRequestsComponent,
    SettingsRequestViewModalComponent,
    SettingsTopBarComponent,
    SettingsTypesComponent,
    SettingsTypesAuditComponent,
    PromoteSettingModalComponent,
    SettingUnitsPipe,
    SettingValuePipe,
    SettingValueSelectorComponent,
    VideoProfileSelectorComponent,
    SimplePaginatorComponent,
    StatusReportHeader,
    TabbedNavigationComponent,
    TimelineComponent,
    TimestampRowComponent,
    ValueCellComponent,
    VideoProfileCellComponent,
    ViewCoreFirmwareModalComponent,
    ViewModuleVersionModalComponent,
    ViewOrDownloadComponent,
    WorkingListComponent,
    WorkingListSearchComponent,
    NewSettingModalComponent,
  ],
  imports: [
    AgGridModule,
    AppRoutingModule,
    BackButtonComponent,
    BillboardComponent,
    BrowserAnimationsModule,
    BrowserModule,
    ChipComponent,
    CommonModule,
    CohortStatusIndicatorComponent,
    DownloadCsvButtonComponent,
    DropdownComponent,
    EntityPathPipe,
    EntitySearchComponent,
    FleetTrackerModule,
    FormsModule,
    HttpClientModule,
    LightgalleryModule,
    LytxPlatformComponentsModule,
    NgbModalModule,
    NgbTypeaheadModule,
    NgChartsModule,
    NgSelectModule,
    PermissionsModule,
    ReactiveFormsModule,
    ResetButtonComponent,
    SearchButtonComponent,
    ShareLinkButtonComponent,
    SpinnerComponent,
    LoadingIndicatorComponent,
    ScrollingModule,
    DragDropModule,
    SharedModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
    }),
    CloseButtonComponent,
  ],
  providers: [
    DatePipe,
    FleetTrackerConfig,
    FleetTrackerIconService,
    FleetTrackerUtilityService,
    MapScriptLoaderService,
    SessionService,
    { provide: HTTP_INTERCEPTORS, useClass: CompressionInterceptor, multi: true },
    DeviceViewService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
